import classes from '../WorkQDrawer.module.css'

export default function BlockHeaderComponent({title, goToCaseTabHandler}) {    
    return <div className={classes.block_header}>
        <h3>{title}</h3>
        <button onClick={goToCaseTabHandler}><i className='ti ti ti-arrow-up-right'></i></button>
    </div>
}